// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3u-Rv","title":"ClientReferral_title__yoc3G","itemText":"ClientReferral_itemText__19ByR"};